import { render, staticRenderFns } from "./SearchBarSimple.vue?vue&type=template&id=3edc0db2&"
import script from "./SearchBarSimple.vue?vue&type=script&lang=js&"
export * from "./SearchBarSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchBarSimple.vue"
export default component.exports